import { useSelector } from "react-redux"
import TasksRow from "../../../tasks/TasksRow"
import { tasks_table_header_cells } from "../../../../assets/data";
import MockRows from "../../../mock/MockRows";

export default function TasksList() {
    const tasksList = useSelector(state => state.tasks.dashboardList)
    const loading = useSelector(state => state.tasks.loading)
    return <>
        {loading && 
            <MockRows numberOfRows={tasks_table_header_cells.length}/>
        }
        {tasksList && tasksList.data && tasksList.data.map(itemData => (
           <TasksRow key={itemData.id} itemData={itemData} />
        ))}
        {!tasksList || (tasksList && tasksList.data && tasksList.data.length == 0) && <tr>
            <td colSpan={tasks_table_header_cells.length}>No items found</td>
        </tr>}
    </>
}